import {JSEncrypt} from "jsencrypt";

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDKFJlMulCxYLXEAhlwT16/noBIgbdT55Q7x+eOw7KZ9vaMxKG0L4sKHuJ6f+dDjqxi8R6Bg8bM2VZdxyGUB0JbzJxv2QydBhIoTitNAPrqZb9LvzWLOPxZOi8zsx5/3jx6RTrxmOAv7PUC1qpHHu3wTCcYp/wl6rjzAP9E+DbwhQIDAQAB'

export function encryption(value) {
    let encryptor = new JSEncrypt()  // 新建JSEncrypt对象
    encryptor.setPublicKey(publicKey)  // 设置公钥
    return encryptor.encrypt(value)
}